module.exports = __webpack_public_path__ + "img/1.49d04429.jpg";